<template>
   <div v-if="refreshDom" class="login-page">
     <img class="login-bg" :src="file[fileId]"/>
    <LoginCard></LoginCard>
   </div>
</template>

<script lang='js'>
import Vue from 'vue'
import LoginCard from '@/components/Login/LoginCard'
import { remove } from '@/util/localStorage'
import { mapState, mapGetters } from 'vuex'

const Login = Vue.extend({
  name: 'Login',
  data: function () {
    return {
      userNumber: '',
      password: '',
      loginStatus: this.$t('Auth.login'),
      refreshDom: true,
      fileId: 1002
    }
  },
  components: {
    LoginCard
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    })
  },
  watch: {
    isFileChange () {
      this.refresh()
    }
  },
  mounted () {
    sessionStorage.clear()
    remove()
    if (!this.$store.state.resource.status[this.fileId]) {
      this.$store.dispatch('resource/getFileTypePublic', this.fileId)
      // .then(() => {
      //   document.getElementsByClassName('login-page')[0].style.backgroundImage = this.file[this.fileId]
      // })
    }
  },
  methods: {
    login: function () {
      localStorage.userNumber = this.userNumber
      this.$store.dispatch('auth/userLoginWithNumber', { userNumber: this.userNumber, password: this.password })
        .then(() => {
          this.loginStatus = this.$t('Auth.loging')
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    }
  }
})

export default Login
</script>

<style>
.login-page {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  /* background-image: url('../../assets/Login/ditu.jpg'); */
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}
.login-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
